import { render, staticRenderFns } from "./activitiesVideo1.vue?vue&type=template&id=5ac0df8b&scoped=true"
import script from "./activitiesVideo1.vue?vue&type=script&lang=js"
export * from "./activitiesVideo1.vue?vue&type=script&lang=js"
import style0 from "./activitiesVideo1.vue?vue&type=style&index=0&id=5ac0df8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0df8b",
  null
  
)

export default component.exports